import {
  Component,
  inject,
  input,
  InputSignal,
  OnInit,
  output,
  OutputEmitterRef,
} from "@angular/core";
import { AppConfig } from "../../app.config";

@Component({
  selector: "regimen-concern-selection",
  templateUrl: "./regimen-concern-selection.html",
  standalone: false,
})
export class RegimenConcernSelectionComponent implements OnInit {
  public readonly appConfig: AppConfig = inject(AppConfig);

  acqRebranding2025: InputSignal<boolean> = input();
  concernClass: InputSignal<any> = input();
  gender: InputSignal<string> = input("female");
  isRebranding: InputSignal<boolean> = input(false);

  selectConcern: OutputEmitterRef<string> = output();

  faceIconUrl: string;
  hairIconUrl: string;

  ngOnInit(): void {
    this.setIconUrls();
  }

  onSelectConcern(concernClass: string): void {
    this.selectConcern.emit(concernClass);
  }

  setIconUrls(): void {
    if (this.gender() === this.appConfig.Shared.Gender.MALE) {
      this.faceIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-male-face.svg";
      this.hairIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-male-hair.svg";
    } else {
      this.faceIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-female-face.svg";
      this.hairIconUrl =
        "https://cdn.cureskin.com/app/img/rebranded-female-hair.svg";
    }
  }
}
